/**
 * @file LlFormItem组件引出
 */

import { withInstall } from '@ll-plus/utils'

import FormItem from './src/form-item.vue'

export const LlFormItem = withInstall(FormItem)
export default LlFormItem
export * from './src/form-item'

declare module 'vue' {
  export interface GlobalComponents {
    LlFormItem: typeof LlFormItem
  }
}
